import React, { useState } from 'react';
import { classNames } from '../../utils/style';
import { Accordion } from '../Accordion';
import { Body } from './Body';
import { getHeaders } from './logic';

export interface ComparisonTableRow {
  rowLabel: string;
  values: { [key: string]: boolean };
}

export interface ComparisonTableProps {
  title?: string;
  data: ComparisonTableRow[];
  isSmall?: boolean;
  offers?: any[];
}

export const Table = ({
  title,
  data,
  isSmall,
  offers,
}: ComparisonTableProps) => {
  const headers = getHeaders(data);
  const [isOpen, setIsOpen] = useState(true);

  return (
    <div
      className={classNames(
        'ComparisonTableTable',
        'overflow-hidden rounded-18 border border-blue-51',
        'mb-24',
      )}
    >
      <Accordion
        index={0}
        defaultValue={true}
        question={title || ''}
        answer={
          <Body
            headers={headers}
            data={data}
            isSmall={isSmall}
            offers={offers}
          />
        }
        onClick={(e, { open: _open }) => {
          setIsOpen(_open);
        }}
      >
        <Accordion.Button
          className={classNames(
            'bg-blue-51 p-16 text-14 font-semibold text-neutral-301',
            'flex w-full items-center justify-between',
          )}
        >
          {title}
          {isOpen ? (
            <svg
              width="12"
              height="8"
              viewBox="0 0 12 8"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1.41 7.41L6 2.83L10.59 7.41L12 6L6 0L0 6L1.41 7.41Z"
                fill="#0F6FDE"
              />
            </svg>
          ) : (
            <svg
              width="12"
              height="8"
              viewBox="0 0 12 8"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1.41 0.589844L6 5.16984L10.59 0.589844L12 1.99984L6 7.99984L0 1.99984L1.41 0.589844Z"
                fill="#0F6FDE"
              />
            </svg>
          )}
        </Accordion.Button>
        <Accordion.Content animOnClose={true} className="" />
      </Accordion>
    </div>
  );
};
